import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Category {
  id: string;
  category: string;
  [key: string]: any;
}

export interface Schedule {
  id: string;
  day_names: string[];
  start_time: string;
  end_time: string;
  [key: string]: any;
}

export interface Store {
  id: string;
  name: string;
  address?: string;
  streetName?: string;
  streetNumber?: string;
  apartment?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
  latitude?: number;
  longitude?: number;
  categories?: Category[];
  schedules?: Schedule[];
  operationalStatus?: string;
  statusMessage?: string | null;
  lastStatusUpdate?: string | null;
  merchant?: any;
  [key: string]: any;
}

export interface CreateStorePayload {
  name: string;
  address?: string;
  city?: string;
  phoneNumber?: string;
  streetName?: string;
  streetNumber?: string;
  apartment?: string;
  state?: string;
  zipCode?: string;
  categories: string[];
  schedules: string[];
  latitude?: number;
  longitude?: number;
}

export interface UpdateStorePayload extends CreateStorePayload {
  id: string;
}

interface StoresState {
  activeStoreId: string | null;
}

const initialState: StoresState = {
  activeStoreId: localStorage.getItem('activeStoreId') || null,
};

const storesSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    setActiveStore: (state, action: PayloadAction<string | null>) => {
      state.activeStoreId = action.payload;
      if (action.payload) {
        localStorage.setItem('activeStoreId', action.payload);
      } else {
        localStorage.removeItem('activeStoreId');
      }
    },
  },
});

export const { setActiveStore } = storesSlice.actions;
export default storesSlice.reducer;
